export const MIN_REVIEWS_FOR_GPT = 10;
export const MAX_REVIEWS_PER_GPT_REQUEST = 1000;
